export enum FieldAssertion {
    Day = "day",
    Month = "month",
    Year = "year",
    Place = "place",
}
